/**
 *
 */
export enum CoolingWorkUnit {
    Kwc = "kWc",
    Tons = "tons",
}